import { render, staticRenderFns } from "./CalendarDayBreakdownEvent.vue?vue&type=template&id=2dad8502"
import script from "./CalendarDayBreakdownEvent.vue?vue&type=script&lang=js"
export * from "./CalendarDayBreakdownEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports